<template>
  <Loading v-if="!fullyLoaded" />
  <ChemicalCostForm v-else :chemicals="chemicals" :submit="submit" :cancel="cancel" />
</template>

<script>
import CreateView from '@/mixins/createView';
import ResourceService from '@/services/resources/chemical_costs_service';
import ChemicalService from '@/services/resources/chemicals_service';

export default {
  mixins: [CreateView],
  components: {
    ChemicalCostForm: () => import('@/components/forms/ChemicalCostForm.vue'),
  },
  data() {
    return {
      urlFragment: 'chemicals',
      resourceService: ResourceService,
    };
  },
  asyncComputed: {
    chemicals: {
      get() {
        return ChemicalService.index({
          filter: { without_cost_on_site: this.$route.params.site_id },
        }).then((chemicals) => {
          return chemicals.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
};
</script>
